export const common = {
  nav: {
    home: 'Home',
    services: 'Services',
    pricing: 'Pricing',
    faqs: 'FAQs',
    contact: 'Contact',
    customSolutions: 'Custom Solutions',
    demo: 'Demo'
  },
  footer: {
    description: 'Automation and AI for service businesses',
    quickLinks: 'Quick Links',
    legal: 'Legal',
    legalNotice: 'Legal Notice',
    privacy: 'Privacy',
    cookies: 'Cookies',
    contact: 'Contact',
    email: 'info@velxia.es',
    rights: '© 2026 VELXIA. All rights reserved.'
  },
  cta: {
    learnMore: 'Learn More',
    getStarted: 'Get Started',
    contact: 'Contact Us',
    backHome: 'Back to Home',
    bookDemo: 'Book Demo',
    requestDemo: 'Request Demo',
    send: 'Send',
    requestInfo: 'Request Information'
  },
  form: {
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    company: 'Company',
    message: 'Message',
    optional: '(optional)',
    response24h: 'We will respond within 24 hours'
  },
  backToHome: 'Back to Home'
};
